/* eslint-disable */
import {Module, VuexModule, Mutation} from 'vuex-module-decorators';
import _ from 'underscore';

import {Country, CountryConditionsState} from './types';

export const state: CountryConditionsState = {
    countryConditions: [],
};

const namespaced: boolean = true;

@Module({
    namespaced,
})
export default class CountryConditionsStore extends VuexModule {
    countryConditions: Country[] = [];

    @Mutation
    updateCountryConditions(countryConditions: Country[]): void {
        const currentCoutryConditions = this.countryConditions;
        let newCountryCondititons = [
            ...currentCoutryConditions,
        ];
        countryConditions.forEach((countryCondition) => {
            const currentCoutryCondition = _.find(currentCoutryConditions, (currentCoutryCondition) => currentCoutryCondition.id === countryCondition.id);
            if (currentCoutryCondition) {
                newCountryCondititons = _.without(newCountryCondititons, currentCoutryCondition);
            }
            newCountryCondititons.push(countryCondition);
        });
        this.countryConditions = newCountryCondititons;
    }
}